/* eslint camelcase: 0, function-paren-newline: 0, no-unused-vars: 0 */
/* global $ */
/* This is a small set of scripts that can be included to override
   the initial labels and placeholders for NGP forms. This relies on
   a JavaScript object, nvtag_callbacks, created outside the scope of this script.
*/

window.nvtag_callbacks = window.nvtag_callbacks || {};

const { ngpFormData } = window;
const { nvtag_callbacks } = window;

nvtag_callbacks.alterFormDefinition = nvtag_callbacks.alterFormDefinition || [];
nvtag_callbacks.postRender = nvtag_callbacks.postRender || [];

const {
	FirstName,
	LastName,
	PostalCode,
	EmailAddress,
	YesSignMeUpForUpdatesForBinder,
	TrackingPixel,
	PersonalUrl,
} = ngpFormData || {};

const updateLabels = function (args) {
	// for refererence
	// In order to update labels, you have to update the props of the individual form fields.
	// The console here will show you the form elements, which contains form content, fields, etc
	// console.log({ args }, { elements: args.form_definition.form_elements[2] });
	const formElements = args.form_definition.form_elements;

	// Iterate over each form's elements and set children as fields variable
	formElements.forEach((form, i) => {
		const formElement = args.form_definition.form_elements[i];

		// Only run the fields update on the contact information object
		if (formElement.name === 'ContactInformation') {
			// Children is the fields on the form itself
			const fields = formElement.children;

			// Iterate over each form element's children (set above as fields variable)
			// Update the individual form fields with corresponding labels
			fields.forEach((field, j) => {
				if (ngpFormData[field.name]) {
					const { label } = ngpFormData[field.name];
					if (label) {
						field.title = label;
					}
				}
			});
		}
	});

	return args;
};

nvtag_callbacks.alterFormDefinition.push(updateLabels);

const updatePlaceholders = function () {
	$('body')
		.find('.at-form')
		.each((index, form) => {
			const $form = $(form);

			$form.find('input').each((i, el) => {
				const $input = $(el);
				const name = $input.attr('name');
				if (ngpFormData[name]) {
					const { placeholder } = ngpFormData[name];
					if (placeholder) {
						$input.attr('placeholder', placeholder);
					}
				}
			});
		});
};

nvtag_callbacks.postRender.push(updatePlaceholders);

let submitPosition = document.body.scrollTop;

const withSubmit = function (e) {
	submitPosition = $('body').get(0).scrollTop;
	console.log(submitPosition, 'pre-submit pos');
};

const reorderFields = function () {
	$('body')
		.find('.at-form')
		.each((index, form) => {
			const $form = $(form);

			const $emailRow = $form.find('.at-row.EmailAddress');
			const $zipRow = $form.find('.at-row-solo.PostalCode');

			$emailRow.after($zipRow);

			form.addEventListener('submit', withSubmit);
		});
};

nvtag_callbacks.postRender.push(reorderFields);

const afterSubmit = function (event) {
	const row = $(event.currentTarget).closest('.row').get(0);

	console.log('after submit', event, event.currentTarget, row);

	if (row && row.scrollIntoView) {
		console.log('scrolling into view', row);
		row.scrollIntoView();
		setTimeout(() => {
			row.scrollIntoView();
		}, 300);
	} else {
		console.log('scrolling into view', submitPosition);
		$('body').scrollTop(submitPosition);
		setTimeout(() => {
			$('body').scrollTop(submitPosition);
		}, 100);
	}
};
nvtag_callbacks.onSubmit = nvtag_callbacks.onSubmit || [];
nvtag_callbacks.onSubmit.push(afterSubmit);
